import { render, staticRenderFns } from "./Identity.vue?vue&type=template&id=861957ea&scoped=true&"
import script from "./Identity.vue?vue&type=script&lang=js&"
export * from "./Identity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861957ea",
  null
  
)

export default component.exports